/**
 * Opens the sidebar by setting the appropriate CSS properties
 * This function sets the overflow to hidden and slides in the sidebar
 */
export const openSidebar = () => {
  if (typeof document !== "undefined") {
    document.body.style.overflow = "hidden";
    document.documentElement.style.setProperty("--SideNavigation-slideIn", "1");
  }
};

/**
 * Closes the sidebar by removing the CSS properties
 * This function removes the overflow and slide-in properties
 */
export const closeSidebar = () => {
  if (typeof document !== "undefined") {
    document.documentElement.style.removeProperty("--SideNavigation-slideIn");
    document.body.style.removeProperty("overflow");
  }
};

/**
 * Toggles the sidebar state between open and closed
 * Checks the current state and calls the appropriate function
 */
export const toggleSidebar = () => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--SideNavigation-slideIn");
    if (slideIn) {
      closeSidebar();
    } else {
      openSidebar();
    }
  }
};

/**
 * Opens the messages pane by setting the appropriate CSS properties
 * This function sets the overflow to hidden and slides in the messages pane
 */
export const openMessagesPane = () => {
  if (typeof document !== "undefined") {
    document.body.style.overflow = "hidden";
    document.documentElement.style.setProperty("--MessagesPane-slideIn", "1");
  }
};

/**
 * Closes the messages pane by removing the CSS properties
 * This function removes the overflow and slide-in properties
 */
export const closeMessagesPane = () => {
  if (typeof document !== "undefined") {
    document.documentElement.style.removeProperty("--MessagesPane-slideIn");
    document.body.style.removeProperty("overflow");
  }
};

/**
 * Toggles the messages pane state between open and closed
 * Checks the current state and calls the appropriate function
 */
export const toggleMessagesPane = () => {
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    const slideIn = window
      .getComputedStyle(document.documentElement)
      .getPropertyValue("--MessagesPane-slideIn");
    if (slideIn) {
      closeMessagesPane();
    } else {
      openMessagesPane();
    }
  }
};
